export const REQUEST_TRANSACTIONS = 'REQUEST_TRANSACTIONS';
export const RECEIVED_TRANSACTIONS_ERROR = 'RECEIVED_TRANSACTIONS_ERROR';
export const RECEIVED_TRANSACTIONS = 'RECEIVED_TRANSACTIONS';

export const REQUEST_REFUND_EXPANSION_TOGGLE = 'REQUEST_REFUND_EXPANSION_TOGGLE';
export const BUNDLE_SETTING = 'BUNDLE_SETTING';
export const USER_SETTING = 'USER_SETTING';

// Elmo config checker
export const PREPARE_ELMO_CONFIG = 'PREPARE_ELMO_CONFIG';
export const RECEIVED_ELMO_CONFIG = 'RECEIVED_ELMO_CONFIG';
export const RECEIVED_ELMO_CONFIG_ERROR = 'RECEIVED_ELMO_CONFIG_ERROR';

// Client Customized data
export const CUSTOMIZED_CONFIG = 'CUSTOMIZED_CONFIG';
